export default __webpack_public_path__ + "static/nidec-logo-8f900beac553d9c5f2add42aea979d4c.png";